import getters from './getters'

export default function extendUser (storeUser) {
  storeUser.getters = getters
  return storeUser
}
